import React, { useEffect, useState, useRef, useContext } from "react";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import {loadStripe} from '@stripe/stripe-js';

import AddCardInformationComponent from './AddCardInformationComponent';
import AddWeb2CardComponent from './AddWeb2CardComponent';
import Web2CardAfterComponent from './Web2CardAfterComponent';

import {UserContext} from '../../../utils/userDetailsProvider';
import {PaymentContext} from '../../../utils/paymentConfigProvider';

import {CREATE_STRIPE_PAYMENT_INTENT} from '../../../constants/urls';
import { getLoginInformation} from '../../../utils/loginHelper';

const SHOW_CARD_INFO = 1;
const SHOW_ADD_CARD = 2;
const SHOW_CARD_AFTER = 3;


const SUCCESS_MESSAGE = "Congrats Card Added!";
const PROCESSING_MESSAGE = "Processing, Will Notify later";
const FAIL_MESSAGE = "Failed to add.";

let prodKey = 'pk_live_51HjSRkBT9Re7oqqohGqMvLKx77mxVIuStCb3NtBXOVgVG7RwO94erW2QQRfIF3VJV6nSLKMha0gqxCuUp009lFSu00OtRfpSgc';
let stageKey = 'pk_test_51HjSRkBT9Re7oqqozwSAxBffWK1LTkWzEMz4mm8mi2djhjrXQw1JLYyziXHkvOdYy7l7WPvSg1RNrmf0092MbPBi00rMhSkk2O';

//const stripePromise = loadStripe(stageKey);
const stripePromise = loadStripe(prodKey);

function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

export function Web2CardManagerComponent(props){
    const stripe = useStripe();
    const [message, setMessage] = useState(null);
    const [isOpen, setIsOpen] = useState(props.isOpen);
    const forceUpdate = useForceUpdate();
    const currDisplayedComp = useRef(SHOW_CARD_INFO);

    useEffect(()=>{
        setIsOpen(props.isOpen);
    },[props.isOpen])
    
    const handleComponentCheck = ()=>{
        if(props.startsWithAddCard){
            currDisplayedComp.current = SHOW_ADD_CARD;
            forceUpdate();
        }
    }

    const handleModalCloseEvent = () => {
        setIsOpen(false);
        props.handleModalCloseEvent();
    }
    
    useEffect(()=>{
        console.log('open changed bitches');
	handleComponentCheck();
    },[props.startsWithAddCard, props.isOpen]);

    useEffect(() => {
        if (!stripe) {return;}
        const clientSecret = new URLSearchParams(
            window.location.search).get('setup_intent_client_secret');
        if(!clientSecret){
            return;
        }
        // crearing url params
        window.history.pushState(
            {}, document.title, window.location.href.split('?')[0]);
        stripe
            .retrieveSetupIntent(clientSecret)
            .then(({setupIntent}) => {
                currDisplayedComp.current = SHOW_CARD_AFTER;
                setIsOpen(true);
                switch (setupIntent.status) {
                    case 'succeeded':
                        setMessage(SUCCESS_MESSAGE);
                        break;

                    case 'processing':
                        setMessage(PROCESSING_MESSAGE);
                        break;

                    case 'requires_payment_method':
                        setMessage(FAIL_MESSAGE);
                        break;
                }
            });
    }, [stripe]);


    const moveToAddCard = ()=> {
        console.log('move to add card called');
        currDisplayedComp.current = SHOW_ADD_CARD;
        forceUpdate();
    }

    return (
        <>
            {(currDisplayedComp.current === SHOW_CARD_INFO) && (
                <AddCardInformationComponent
                    isOpen={isOpen}
                    handleModalCloseEvent={handleModalCloseEvent}
                    moveToAddCard={()=>{moveToAddCard()}}
                >
                </AddCardInformationComponent>
            )}
            {((currDisplayedComp.current === SHOW_ADD_CARD)) && (
                <AddWeb2CardComponent
                    isOpen={isOpen}
                    handleModalCloseEvent={handleModalCloseEvent}
                >
                </AddWeb2CardComponent>
            )}
            {(currDisplayedComp.current === SHOW_CARD_AFTER) && (
                <Web2CardAfterComponent
                    handleModalCloseEvent={handleModalCloseEvent}
                    isOpen={isOpen}>
                </Web2CardAfterComponent>
            )}
        </>
    )
}

export default function DecorateWeb2CardManagerComponent(props){
    const [clientSecret, setClientSecret] = useState("");
    
    const userDetails = useContext(UserContext);
    const paymentConfig = useContext(PaymentContext);

    console.log('paymentConfig', paymentConfig);

    let isIndiaPayment = false;
    if(paymentConfig && paymentConfig.acceptedGateways){
        isIndiaPayment = (
            (paymentConfig.acceptedGateways.includes('razorpay'))?true:false);
    }
    
    
    const appearance = {
	theme: 'night',
        labels: 'floating'
    };
    const options = {
        clientSecret,
        appearance,
    };
    
    const createPaymentIntent = () => {
	let url  = CREATE_STRIPE_PAYMENT_INTENT;
        let loginInformation = getLoginInformation();
        console.log('loginInformation', loginInformation);
	fetch(url, {
	    method: "POST",
	    headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${loginInformation.accessToken}`
            },
	    body: JSON.stringify({bid:{}}),
	}).then((res) => res.json())
	  .then((data) => {             
              setClientSecret(data.clientSecret);
          });
    }
    
    useEffect(()=>{
        createPaymentIntent();
    },[]);
    
    return (
        <>
            {(isIndiaPayment) && (
                <></>
            )}
            {(!isIndiaPayment) && (
                <>
                    {(clientSecret) && (
                        <Elements options={options} stripe={stripePromise}>
                            <Web2CardManagerComponent {...props}>
                            </Web2CardManagerComponent>
                        </Elements>
                    )}
                    {!clientSecret && (
                        <></>
                    )}
                </>
            )}
        </>
    )
}
